module.exports = __webpack_public_path__ + "img/oaBack_sys.6cd1b478.png";